import { VerifiedItem } from "../../types/verified";
import { BankSourcesTable } from "./components/BankSourcesTable";
import { PayrollTable } from "./components/PayrollTable";
import { PaystubTable } from "./components/PaystubTable";
import { W2Table } from "./components/W2Table";

export const TablesSlice = ({ currentItem }: { currentItem: VerifiedItem }) => {
  switch (currentItem.income_source_type) {
    case "bank":
      return <BankSourcesTable income={[currentItem]} />;
    case "payroll":
      return <PayrollTable income={[currentItem]} />;
    case "w2":
      return <W2Table incomeItems={[currentItem]} />;
    case "paystub":
      return <PaystubTable incomeItems={[currentItem]} />;
  }
};
